import { render } from "./EmpresasIndex.vue?vue&type=template&id=d036659a"
import script from "./EmpresasIndex.vue?vue&type=script&lang=js"
export * from "./EmpresasIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/cruds/EmpresasIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d036659a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d036659a', __exports__)) {
    api.reload('d036659a', __exports__)
  }
  
  module.hot.accept("./EmpresasIndex.vue?vue&type=template&id=d036659a", () => {
    api.rerender('d036659a', render)
  })

}


export default __exports__